import React from 'react';
import { useModel,useBCMSContext,BCMSRecord,DisabledPrompt } from "bcms-react";
import Classes, { Profile } from "model";
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import PageContentView from 'components/shared/views/PageContentView';
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import { ProfilePicker } from '../ChangeProfilePage';


import "./styles.css";
import "./mobile.css";

export default function CHW23Page(props) {
    const branding = useModel().branding.options;
    window.BRANDING = { "cards_abi22": branding.cards_abi22 };
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const profiles = Profile.initAll(); 

    return (
        <PageContainer className="cardhub-web-page integrated-product-page" ignoreTrigger={ true }>
            <PageContentView>
                {branding.multiprofile_abi22 ==="true" &&
                    <ProfilePicker profiles = {profiles} ui={{}} onChange = {()=>{}} onSelectClick={()=>{}} disableBusiness="true"/>
                
                }
                <CenterContentContainer>
                    <ContentHeaderView text="Cards" />
                    <ExternalIframe demo="CHW23" key ="CHW23Page"/>
                </CenterContentContainer>
            </PageContentView>
        </PageContainer>
    );
}